
import * as antIcons from '@ant-design/icons-vue';
import iconData from './icon.js';

export default {
  name: 'EleIconPicker',
  components: {...antIcons},
  emits: ['update:value'],
  props: {
    // dropdown属性
    trigger: {
      type: Array,
      default() {
        return ['click'];
      }
    },
    placement: {
      type: String,
      default: 'bottomLeft'
    },
    // 选中图标
    value: String,
    // 提示文本
    placeholder: String,
    // 尺寸
    size: String,
    // 是否禁用
    disabled: Boolean,
    // 是否显示清除
    allowClear: {
      type: Boolean,
      default: true
    },
    // 是否显示搜索框
    allowSearch: {
      type: Boolean,
      default: true
    },
    // 搜索框提示文本
    searchPlaceholder: {
      type: String,
      default: '搜索..'
    },
    // 图标数据
    data: {
      type: Array,
      default() {
        return iconData;
      }
    }
  },
  data() {
    return {
      // popper是否显示
      visible: false,
      // tab选中
      activeKey: 0,
      // menu选中
      selectedKeys: [0],
      // 搜索关键字
      keywords: '',
      // 搜索后的数据
      result: this.data
    };
  },
  computed: {
    /* 当前tab数据 */
    activeList() {
      if (!this.result.length) {
        return [];
      }
      const temp = this.result[this.activeKey];
      return temp ? temp.children : [];
    },
    /* 当前显示图标数据 */
    currentList() {
      if (!this.activeList.length) {
        return [];
      }
      if (!this.selectedKeys.length) {
        return [];
      }
      const temp = this.activeList[this.selectedKeys[0]];
      return temp ? temp.icons : [];
    }
  },
  methods: {
    /* 选择图标 */
    onChoose(value) {
      this.visible = false;
      this.$emit('update:value', value);
    },
    /* 清除 */
    onClear() {
      this.$emit('update:value', '');
    },
    /* 搜索 */
    onSearch() {
      if (!this.keywords) {
        this.result = this.data;
        return;
      }
      let result = [], firstIndex = -1, activeHave = true;
      this.data.forEach((item, index) => {
        let children = [], haveIcon = false;
        item.children.forEach((child => {
          let icons = child.icons.filter(d => d.toLowerCase().indexOf(this.keywords.toLowerCase()) !== -1);
          if (icons.length) {
            haveIcon = true;
          } else if (index === this.activeKey) {
            activeHave = false;
          }
          children.push({title: child.title, icons: icons});
        }));
        if (firstIndex === -1 && haveIcon) {
          firstIndex = index;
        }
        result.push({title: item.title, children: children});
      });
      this.result = result;
      if (!activeHave && firstIndex !== -1) {
        this.activeKey = firstIndex;
      }
    }
  }
}
